import { memo } from 'react'
import { useSelector } from 'react-redux'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'
import Text from 'common-components/Text'
import VideoIllustration from 'assets/svgr-icons/Illustration_Video.svg'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { ASPECT_RATIO_PER_TYPE } from 'containers/SubSidebar/AiImageContent/consts'

const BlankCanvas: React.FC = () => {
  const { aspectRatioString } = useSelector(
    projectDataSelectors.defaultDimensions
  )
  const isPortrait = aspectRatioString === ASPECT_RATIO_PER_TYPE.portrait

  return (
    <Styled.Container>
      <Styled.IllustrationWrapper $isPortrait={isPortrait}>
        <VideoIllustration />
      </Styled.IllustrationWrapper>
      <Text type="subtitle" color="secondary" align="center" fontWeight="400">
        {translate(T.WELCOME_CANVAS_SUBTITLE)}
      </Text>
    </Styled.Container>
  )
}

export default memo(BlankCanvas)
